// extracted by mini-css-extract-plugin
export default {"info__container":"homeGaugeTable_info__container__r18XG","flows__table":"homeGaugeTable_flows__table__v6jwX","sort__header":"homeGaugeTable_sort__header__CJ+U9"};